import React from 'react';
import { Star, Calendar, Music, GlassWater, Clapperboard, ArrowRight } from 'lucide-react';
import SectionHeader from '../components/SectionHeader';
import ServiceCard from '../components/ServiceCard';

const Services = () => {
  return (
    <section id="services" className="py-24 md:py-32 px-6 bg-black relative">
      <div className="container mx-auto max-w-6xl">
        <SectionHeader 
          title="Our Expertise" 
          subtitle="Comprehensive solutions for the entertainment industry, executed with flawlessness."
        />
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          <ServiceCard 
            index={1}
            icon={Calendar}
            title="Event Management"
            description="End-to-end planning and execution for corporate galas, launches, and festivals. Precision planning meets creative vision."
            linkTo="/services/event-management"
          />
           
           
              <ServiceCard 
                index={2}
                icon={GlassWater}
                title="Club Events"
                description="Curating high-energy nightlife experiences. From DJ bookings to thematic production, we define the pulse of the city."
                linkTo="/services/club-events"
              />
          <ServiceCard 
            index={0}
            icon={Star}
            title="Celebrity Management"
            description="Strategic representation and booking for artists, influencers, and public figures. We handle the logistics so talent can focus on the art."
            linkTo="/services/celebrity-management"
          />
          <ServiceCard 
            index={3}
            icon={Music}
            title="Private Events"
            description="Bespoke gatherings for select clients. Intimate, exclusive, and strictly confidential luxury experiences."
            linkTo="/services/private-events"
          />
          <ServiceCard 
            index={4}
            icon={Clapperboard}
            title="Production"
            description="Full-scale technical production including sound, light, and stage design. We build the canvas for the performance."
            linkTo="/services/production"
          />
          <div className="relative p-8 border border-zinc-800 flex items-center justify-center bg-zinc-900/10 group cursor-pointer hover:bg-zinc-900/30 transition-colors">
            <div className="text-center group-hover:translate-x-2 transition-transform duration-300">
              <span className="text-lg font-medium text-white uppercase tracking-widest flex items-center justify-center gap-3">
                View All Work <ArrowRight size={18} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;